import _defineProperty from "/app/workspaces/v_1/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { UploaderBlock } from '../../abstract/UploaderBlock.js';
export class ProgressBarCommon extends UploaderBlock {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init$", {
      ...this.init$,
      visible: false,
      value: 0,
      '*commonProgress': 0
    });
  }
  initCallback() {
    super.initCallback();
    /** @private */
    this._unobserveCollection = this.uploadCollection.observeProperties(() => {
      let anyUploading = this.uploadCollection.items().some(id => {
        let item = this.uploadCollection.read(id);
        return item.getValue('isUploading');
      });
      this.$.visible = anyUploading;
    });
    this.sub('visible', visible => {
      if (visible) {
        this.setAttribute('active', '');
      } else {
        this.removeAttribute('active');
      }
    });
    this.sub('*commonProgress', progress => {
      this.$.value = progress;
    });
  }
  destroyCallback() {
    var _this$_unobserveColle;
    super.destroyCallback();
    (_this$_unobserveColle = this._unobserveCollection) === null || _this$_unobserveColle === void 0 || _this$_unobserveColle.call(this);
  }
}
ProgressBarCommon.template = /* HTML */" <lr-progress-bar set=\"visible: visible; value: value\"></lr-progress-bar> ";